import { ReactElement } from 'react';

export type HomePageHeroTextVariant =
  | 'CONTROL'
  | 'V1'
  | 'V2'
  | 'V3'
  | 'V4'
  | 'V5'
  | 'V6'
  | 'V7'
  | 'V8';

const heroTextVariantMap: Record<HomePageHeroTextVariant, ReactElement> = {
  CONTROL: (
    <>
      Win Prizes,
      <br className="desktopOnly" /> Plant Trees
    </>
  ),
  V1: (
    <>
      Win what you
      <br />
      actually want
    </>
  ),
  V2: (
    <>
      Your One-Stop
      <br className="mobileOnly" /> Prize
      <br className="desktopOnly" /> Platform
    </>
  ),
  V3: <>Win feel good prizes</>,
  V4: <>The place to win</>,
  V5: (
    <>
      Win prizes <br className="mobileOnly" /> every week
    </>
  ),
  V6: (
    <>
      Prizes that will <br className="mobileOnly" /> make your day
    </>
  ),
  V7: <>Win amazing prizes</>,
  V8: (
    <>
      The feel-good <br className="mobileOnly" /> way to win
    </>
  ),
};

export function getCurrentHeroText(variant: string): ReactElement {
  return heroTextVariantMap[variant as HomePageHeroTextVariant];
}
